import config from 'constants/config'
import getPaymentMethods from 'lib/payment/getPaymentMethods'
import {
  APPLE_PAY_PAYMENT_TYPE,
  GOOGLE_PAY_PAYMENT_TYPE,
} from 'constants/payment'

export const isExpressCheckoutEnabled = (currency: string): boolean =>
  !!(config.EXPRESS_PAYMENT_ENABLED) && (getPaymentMethods(currency).includes(APPLE_PAY_PAYMENT_TYPE) || getPaymentMethods(currency).includes(GOOGLE_PAY_PAYMENT_TYPE))
